import styled from 'styled-components';
import { Card } from '@interstate/components/Card';

export const StyledCard = styled(Card)`
    border: none !important;

    && .ids-action {
        font-size: 18px;
        font-weight: 600;
    }
`;
